import React, { useRef, useState, useEffect } from 'react';
import { Button } from '../../bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { closeDetail } from '../redux/dashboardSlice';
import Scrollbars from 'react-custom-scrollbars-2';
import styles from './DetailSidebarSettings.module.scss';
import sidebarStyles from '../../common/Sidebar/Sidebar.module.scss';
import { useElementWidth } from '../hooks/useElementWidth.js';

export const SIDEBAR_SETTING_TYPES = {
  axis: 'axis',
  series: 'series',
  task_status: 'task_status',
  dataset: 'dataset',
  datasource_value: 'datasource_value',
  grid_column: 'grid_column',
  advanced_filter_button: 'advanced_filter_button'
}

function DetailSidebarSettings({ saveSettings, onClose = () => {}, validate = () => {return true}, sidebarId, children }){
  const dispatch = useDispatch();
  const loading = useSelector(state => state.dashboard.loading);
  const detailOpenId = useSelector(state => state.dashboard.detailOpenId);
  const containerRef = useRef(null);
  const contentWidth = useElementWidth(containerRef);

  const discardChange = () => {
    if (validate()){
      onClose();
    }
    dispatch(closeDetail());
  }

  const handleSave = () => {
    if (validate()){
      saveSettings();
    }
  }

  if (!detailOpenId || detailOpenId !== sidebarId){
    return null
  }

  return (
    <div className={styles['settings-sidebar-wrapper']} ref={containerRef} >
      <div className={`${styles['settings-sidebar-container']} ${sidebarStyles['base-sidebar']}`} style={{width: contentWidth + 1}}>
        <Scrollbars autoHide>
          <div className={`${sidebarStyles['content-padding']} ${styles['settings-sidebar-content']}`}>
            {children}
          </div>
        </Scrollbars>
        <div className={sidebarStyles['sidebar-footer']} style={{zIndex: 1}}>
          <Button type='default' onClick={discardChange}>{I18n.t('close')}</Button>
          <Button type='primary' elemType='submit' disabled={loading} onClick={handleSave}>{I18n.t('save')}</Button>
        </div>
      </div>
    </div>
  )
}

export default DetailSidebarSettings;
